/*!
 * Google maps default settings
 */
var $ = require('jquery');
require('./jquery.gm');

/* Set Defaults */
$.googlemap.setDefaults({
	mapOptions: {
		streetViewControl: false,
		panControl: true,
		zoomControl: true,
		scrollwheel: false,
		mapTypeControl: false,
		maxZoom: 20
/*
		styles: [
			{
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#2c2c55"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#2c2c55"
					}
				]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "administrative.locality",
				"stylers": [
					{
						"hue": "#2c2e33"
					},
					{
						"saturation": 7
					},
					{
						"lightness": 19
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "administrative.locality",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "administrative.neighborhood",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "administrative.province",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#2c2c55"
					}
				]
			},
			{
				"featureType": "administrative.province",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "landscape",
				"stylers": [
					{
						"hue": "#ffffff"
					},
					{
						"saturation": -100
					},
					{
						"lightness": 100
					},
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "landscape.man_made",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "poi",
				"stylers": [
					{
						"hue": "#ffffff"
					},
					{
						"saturation": -100
					},
					{
						"lightness": 100
					},
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
					{
						"hue": "#bbc0c4"
					},
					{
						"saturation": -93
					},
					{
						"lightness": 31
					},
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#2c2c55"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels",
				"stylers": [
					{
						"hue": "#008eff"
					},
					{
						"saturation": -93
					},
					{
						"lightness": 31
					},
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels",
				"stylers": [
					{
						"hue": "#bbc0c4"
					},
					{
						"saturation": -93
					},
					{
						"lightness": -2
					},
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"hue": "#e9ebed"
					},
					{
						"saturation": -90
					},
					{
						"lightness": -10
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "transit",
				"stylers": [
					{
						"hue": "#e9ebed"
					},
					{
						"saturation": 10
					},
					{
						"lightness": 69
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"stylers": [
					{
						"hue": "#e9ebed"
					},
					{
						"saturation": -78
					},
					{
						"lightness": 67
					},
					{
						"visibility": "simplified"
					}
				]
			}
		]
*/
	},
	markerTypes: [
		{/* 0 */},
		{
			/* 1 */
			icon: {
				url: '/img/google-map/marker_blue.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{
			/* 2 */
			icon: {
				url: '/img/google-map/marker_green.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{
			/* 3 */
			icon: {
				url: '/img/google-map/marker_green_large.png',
				size: new google.maps.Size(56, 56),
				scaledSize: new google.maps.Size(56, 56),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(28, 28)
			},
			shape: {
				coords: [0, 0, 56, 56],
				type: 'rect'
			}
		},
		{
			/* 4 */
			icon: {
				url: '/img/google-map/marker_green_medium.png',
				size: new google.maps.Size(28, 28),
				scaledSize: new google.maps.Size(28, 28),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(14, 14)
			},
			shape: {
				coords: [0, 0, 28, 28],
				type: 'rect'
			}
		},
		{
			/* 5 */
			icon: {
				url: '/img/google-map/marker_green_small.png',
				size: new google.maps.Size(14, 14),
				scaledSize: new google.maps.Size(14, 14),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(7, 7)
			},
			shape: {
				coords: [0, 0, 14, 14],
				type: 'rect'
			}
		},
		{
			/* 6 */
			icon: {
				url: '/img/google-map/marker_blue_large.png',
				size: new google.maps.Size(56, 56),
				scaledSize: new google.maps.Size(56, 56),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(28, 28)
			},
			shape: {
				coords: [0, 0, 56, 56],
				type: 'rect'
			}
		},
		{
			/* 7 */
			icon: {
				url: '/img/google-map/marker_blue_medium.png',
				size: new google.maps.Size(28, 28),
				scaledSize: new google.maps.Size(28, 28),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(14, 14)
			},
			shape: {
				coords: [0, 0, 28, 28],
				type: 'rect'
			}
		},
		{
			/* 8 */
			icon: {
				url: '/img/google-map/marker_blue_small.png',
				size: new google.maps.Size(14, 14),
				scaledSize: new google.maps.Size(14, 14),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(7, 7)
			},
			shape: {
				coords: [0, 0, 14, 14],
				type: 'rect'
			}
		},
		{ /* 9 */
			icon: {
				url: '/img/google-map/marker_phm.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 10 */
			icon: {
				url: '/img/google-map/marker_phm_green.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 11 */
			icon: {
				url: '/img/google-map/marker_servis.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 12 */
			icon: {
				url: '/img/google-map/marker_servis_green.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 13 */
			icon: {
				url: '/img/google-map/marker_mycka.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 14 */
			icon: {
				url: '/img/google-map/marker_mycka_green.png',
				size: new google.maps.Size(41, 41),
				scaledSize: new google.maps.Size(41, 41),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(21, 21)
			},
			shape: {
				coords: [0, 0, 41, 41],
				type: 'rect'
			}
		},
		{ /* 15 */ }
	],
	bubbleContentFormatter: function (mData) {
		var str = '';
		if (mData.title) {
			str += '<strong>' + mData.title + '</strong>';
		}
		if (mData.bubbleContent) {
			str += '<p>' + mData.bubbleContent + '</p>';
		}
		return str;
	}
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/googlemaps-settings.js